import Grid from "../Grid";

// Dom7
import { Dom7 } from "framework7";
let $$ = Dom7;

// Constants & variables definition
const NAVBAR_VERSIONS_BREAKPOINT = 100; // in px
const TRANSPARENT_VERSION_CLASS  = 'navbar-transparent';

let componentWrapper    = $$('.molecule-main-navbar');
let mobileMenuWrapper   = $$('.navbar-mobile-wrapper');
let openMobileMenuCTA   = $$('.navbar-mobile-open');
let closeMobileMenuCTA  = $$('.navbar-mobile-close');

/*
* Toggling transparent & non-transparent version while scrolling
* (only if default page version is transparent)
* */
if (componentWrapper.hasClass(TRANSPARENT_VERSION_CLASS)) {
    $$(window).on('scroll', function (e) {
        if (window.scrollY > NAVBAR_VERSIONS_BREAKPOINT)
            componentWrapper.removeClass(TRANSPARENT_VERSION_CLASS);
        else
            componentWrapper.addClass(TRANSPARENT_VERSION_CLASS);
    });
}

/*
* Mobile menu - toggling
* */

// Open
openMobileMenuCTA.on('click', function (e) {
    mobileMenuWrapper.addClass('show-mobile-navbar');
});

// Close
closeMobileMenuCTA.on('click', function (e) {
    mobileMenuWrapper.removeClass('show-mobile-navbar');
});

/*
* Mobile menu - submenu items toggling
* */
let mobileItemWithSubmenu = $$('.navbar-item-with-submenu');

mobileItemWithSubmenu.on('click', function (e) {
    if (Grid.isOrLarger("lg")) return;
    $$(this).toggleClass('opened');
    $$(this).next().toggleClass('hidden');
});
